/**
 * Terms of Service — chekste.com/terms
 *
 * The text is src/legal/terms.{en,es}.md, published exactly as reviewed (see
 * LegalDocument). Language comes from the shared LanguageContext (useTranslation ->
 * lang), the EN/ES selector already lives in <Header/>. Cross-references to the Privacy
 * Policy and to chekste.com/contact become in-app links; the words are untouched.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import LegalDocument from '../components/LegalDocument';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from '../i18n';
import termsEn from '../legal/terms.en.md';
import termsEs from '../legal/terms.es.md';

export const TERMS_MARKDOWN = { en: termsEn, es: termsEs };

const LINKS = {
  en: [
    { phrase: 'Privacy Policy', to: '/privacy' },
    { phrase: 'PRIVACY POLICY', to: '/privacy' },
    { phrase: 'chekste.com/contact', to: '/contact' },
  ],
  es: [
    { phrase: 'Política de Privacidad', to: '/privacy' },
    { phrase: 'POLÍTICA DE PRIVACIDAD', to: '/privacy' },
    { phrase: 'Privacy Policy', to: '/privacy' },
    { phrase: 'chekste.com/contact', to: '/contact' },
  ],
};

const Terms = () => {
  const navigate = useNavigate();
  const { lang } = useTranslation();
  const l = lang === 'es' ? 'es' : 'en';

  const handleBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />

      <div className="container mx-auto px-4 sm:px-6 py-8 max-w-4xl">
        <button
          onClick={handleBack}
          className="flex items-center gap-2 text-slate-600 hover:text-slate-800 mb-6"
          data-testid="back-button"
        >
          <ArrowLeft className="w-4 h-4" />
          {l === 'es' ? 'Volver' : 'Back'}
        </button>

        <div className="bg-white rounded-xl border border-slate-200 p-6 sm:p-10 shadow-sm">
          <LegalDocument markdown={TERMS_MARKDOWN[l]} links={LINKS[l]} testId="terms" />
        </div>
      </div>
    </div>
  );
};

export default Terms;
